import { render, staticRenderFns } from "./Barkfinder.vue?vue&type=template&id=2de8d91b"
import script from "./Barkfinder.vue?vue&type=script&lang=js"
export * from "./Barkfinder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports